// extracted by mini-css-extract-plugin
var _1 = "BillingStatusView-module__emailInfoContainer--uFkKG";
var _2 = "BillingStatusView-module__limitCalloutContainer--jzBd7";
var _3 = "BillingStatusView-module__noticeWrapper--nsSAl";
export { _1 as "emailInfoContainer", _2 as "limitCalloutContainer", _3 as "noticeWrapper" }
